// Centralised auth storage.
// - device token  -> localStorage (persists across app restarts; remembers the first login, not IP-based)
// - session token -> sessionStorage (cleared when the app/tab closes; forces profile login on every cold start)

export const DEVICE_KEY = 'rmp_device';
export const TOKEN_KEY = 'rmp_token';
export const USER_KEY = 'rmp_user';

export const getDeviceToken = () => localStorage.getItem(DEVICE_KEY);
export const setDeviceToken = (t) => localStorage.setItem(DEVICE_KEY, t);
export const clearDeviceToken = () => localStorage.removeItem(DEVICE_KEY);

export const getSessionToken = () => sessionStorage.getItem(TOKEN_KEY);

export const setSession = (token, user) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getSessionUser = () => {
  try { return JSON.parse(sessionStorage.getItem(USER_KEY)); } catch (e) { return null; }
};

export const clearSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};
